import { createApiSlice } from 'app/createApiSlice'
import moment from 'moment-timezone'
import { API_ATTENDANCE_REPORT } from 'utils/apiList'

export const reportAttendanceApiSlice = createApiSlice.injectEndpoints({
  reducerPath: 'attendance-report/api',
  endpoints(builder) {
    return {
      fetchAttendanceReport: builder.query({
        query({
          page,
          size = 10,
          sortby,
          sortdir,
          s,
          today,
          byUserId,
          from,
          to,
        }) {
          return {
            url: API_ATTENDANCE_REPORT,
            params: {
              search: s,
              page,
              size,
              sortby,
              sortdir,
              today,
              from,
              to,
              byUserId,
            },
          }
        },
      }),
    }
  },
})

export const {
  useFetchAttendanceReportQuery,
  useLazyFetchAttendanceReportQuery,
} = reportAttendanceApiSlice
